import React from 'react';
import { useCssHandles } from '../../utils/functions';
import { selectFirstLevel, setSelectedFirstLevel } from '../../redux/megaMenuSlice';
import { useDispatch, useSelector } from 'react-redux';
import IconCaret from '../icons/IconCaret';

const CSS_HANDLES = ['goBackContainer', 'goBackButton', 'goBackButtonText', 'caretIcon'];

const GoBackButton = ({ blockClass, componentId }) => {
	const dispatch = useDispatch();
	const { handles } = useCssHandles(`vtex-mega-menu-2-x`, CSS_HANDLES, blockClass);
	const selectedFirstLevel = useSelector(selectFirstLevel);

	if (!selectedFirstLevel && selectedFirstLevel !== 0) return null;

	return (
		<div data-selection={componentId} className={`${handles.goBackContainer}`}>
			<button
				className={`${handles.goBackButton} flex items-center`}
				onClick={(e) => dispatch(setSelectedFirstLevel(null))}
			>
				<IconCaret orientation="left" size={18} handle={handles.caretIcon} />
				<span className={`${handles.goBackButtonText} ml3`}>volte</span>
			</button>
		</div>
	);
};

//wrapper to go back button that return goBackButton wrapped in gobackbtnprovider

const GoBackButtonWrapper = ({ blockClass, componentId }) => {
	return <GoBackButton blockClass={blockClass} componentId={componentId} />;
};
export default GoBackButtonWrapper;
